import React, { Component } from 'react';
import _ from 'lodash';
import AVPlayer from '../../components/AVPlayer';
import Context, { contextPropType } from '../../context';
import { withContext } from '../../../Utils';
import FilerrShape from '../../../Previewer/PropsShape/FilerrShape';

import '../index.scss';
import './audio.scss';

class Audio extends Component {

    render() {
        const { filerr, context } = this.props;
        const { onError, setEmbeddedElementRef } = context;
        const mediaUrl = _.get(filerr, 'videoUrls.mediaUrl');

        return (
            <div className="preview-container audio-container">
                <div className="preview preview-audio" onKeyDown={this.handleKeydown}>
                    <div className="thumbnail audio" tabIndex={0} onClick={this.toggleReview}>
                        <AVPlayer filerr={filerr}>
                            {(
                                onTimeUpdate,
                                onProgress,
                                onEnded,
                                handleLoad,
                                setPlayer,
                                onWaiting
                            ) => (
                                <div ref={setEmbeddedElementRef}>
                                    <div className="background"></div>
                                    <audio ref={(ref) => setPlayer(ref)}
                                        src={mediaUrl}
                                        preload="auto"
                                        onTimeUpdate={onTimeUpdate}
                                        onWaiting={onWaiting}
                                        onProgress={onProgress}
                                        onEnded={onEnded}
                                        onError={onError}
                                        onLoadedMetadata={handleLoad}/>
                                </div>
                            )}
                        </AVPlayer>
                    </div>
                </div>
            </div>
        );
    }
}

Audio.propTypes = {
    filerr: FilerrShape.isRequired,
    context: contextPropType
};

const mapContextToProps = (context) => ({
    context
});

export default withContext(Context, mapContextToProps, Audio);
